module.exports = __webpack_public_path__ + "img/gestion-del-tiempo.f19f93c7.png";